var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchSelectedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6964 16.1185C14.3571 16.3561 14.2747 16.8237 14.5123 17.163L17.7569 21.7969C17.9945 22.1362 18.4621 22.2186 18.8014 21.981C19.1407 21.7435 19.2232 21.2758 18.9856 20.9365L15.741 16.3027C15.5034 15.9634 15.0357 15.8809 14.6964 16.1185Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.18923 18.7322C4.56613 17.917 1.4792 13.5084 2.29438 8.88533C3.10955 4.26223 7.51815 1.1753 12.1413 1.99047C16.7644 2.80565 19.8513 7.21425 19.0361 11.8374C18.2209 16.4605 13.8123 19.5474 9.18923 18.7322ZM13.8179 9.93261C14.1572 9.69503 14.2397 9.22737 14.0021 8.88807C13.7645 8.54876 13.2969 8.4663 12.9576 8.70389L8.93809 11.5183L7.74595 9.81579C7.50837 9.47649 7.04071 9.39403 6.70141 9.63161C6.3621 9.86919 6.27964 10.3369 6.51723 10.6762L8.13955 12.9931C8.37713 13.3324 8.84479 13.4148 9.18409 13.1773L13.8179 9.93261Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchSelectedIcon);
export default __webpack_public_path__ + "static/media/SearchSelectedIcon.72edbb5626608c25cc485851ccaeb0e6.svg";
export { ForwardRef as ReactComponent };